<template>
  <ak-card class="one-whole wrapper wrapper--huge">
    <ak-apps-list-table-loading :loading="loading" />
    <ak-display-table v-if="!loading && computedValue.length" rows cosy hover>
      <template v-for="app in computedValue" :key="app._id">
        <ak-apps-list-table-row
          :app="app"
          :app-type="appType"
          :active-account="activeAccount"
          :active-agency="activeAgency"
          :domains="domains"
          :delete-app="deleteApp"
          :clone-app="cloneApp"
          :create-url="createUrl"
          :url-builder-enabled="urlBuilderEnabled"
          :current-view="currentView"
        />
      </template>
    </ak-display-table>
  </ak-card>

  <ak-apps-list-empty-state
    v-if="!loading && !computedValue.length"
    :new-app-link="newAppLink"
    :create-label="createLabel"
  />
</template>

<script>
import DisplayTable from '@akerolabs/akero-vue/src/components/displayTable/DisplayTable.vue'
import Card from '@akerolabs/akero-vue/src/components/cards/Card.vue'
import AppsListTableLoading from './AppsListTableLoading.vue'
import AppsListTableRow from './AppsListTableRow.vue'
import AppsEmptyState from './AppsListEmptyState.vue'
import { defineComponent, computed } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-apps-list-table />
   */
  name: 'AkAppsListTable',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [DisplayTable.name]: DisplayTable,
    [Card.name]: Card,
    [AppsListTableLoading.name]: AppsListTableLoading,
    [AppsListTableRow.name]: AppsListTableRow,
    [AppsEmptyState.name]: AppsEmptyState,
  },

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Object}
     * @description The active account (drilled in or users)
     */
    activeAccount: {
      default: () => ({}),
      type: Object,
    },

    /**
     * @type {Object}
     * @description The active agency (drilled in or users)
     */
    activeAgency: {
      default: () => ({}),
      type: Object,
    },

    modelValue: {
      default: () => [],
      type: Array,
    },

    loading: {
      default: false,
      type: Boolean,
    },

    appType: {
      default: 'pages',
      type: String,
    },

    domains: {
      default: '',
      type: String,
    },

    newAppLink: {
      default: () => ({}),
      type: Object,
    },

    deleteApp: {
      default: () => {},
      type: Function,
    },

    cloneApp: {
      default: () => {},
      type: Function,
    },

    createUrl: {
      default: () => {},
      type: Function,
    },

    urlBuilderEnabled: {
      default: false,
      type: Boolean,
    },
    currentView: {
      type: String,
      default: undefined,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    const computedValue = computed(() => props.modelValue)
    const createLabel = computed(() =>
      props.appType === 'pages' ? 'Page' : 'Form',
    )

    return {
      computedValue,
      createLabel,
    }
  },
})
</script>
